export default "__VITE_ASSET__27ccdec0__"